import { FlexBox, Text, Tooltip } from '@dixa/lib-shared-habla';
import type { MetricInstrument as MetricInstrumentT } from 'lib-analytics-types';
import { MetricInstrument } from 'lib-analytics-ui';
import { PropsWithChildren } from 'lib-shared-types-utils';
import { memo } from 'react';

import { MetricInstrumentsGrid } from '../../../../renderer/components/metricInstrumentsGrid/metricInstrumentsGrid';

import styles from './heatmapInstrumentTooltip.module.scss';

export type HeatmapInstrumentTooltipProps = {
  /** The title of the tooltip. */
  title: string;
  /** The metrics displayed in the content of the tooltip. */
  metrics: readonly MetricInstrumentT[];
} & PropsWithChildren;

export const HeatmapInstrumentTooltip = memo(function HeatmapInstrumentTooltip({
  title,
  metrics,
  children,
}: HeatmapInstrumentTooltipProps): JSX.Element {
  const content: JSX.Element = (
    <FlexBox flexDirection="column" gap="200">
      <Text.Paragraph variant="1" color="white">
        {title}
      </Text.Paragraph>

      {metrics.length > 0 && (
        <MetricInstrumentsGrid bounded>
          {metrics.map((metric, index) => (
            <MetricInstrument key={index} instrument={metric} theme="dark" />
          ))}
        </MetricInstrumentsGrid>
      )}
    </FlexBox>
  );

  return (
    <Tooltip
      content={content}
      dark
      wrap="div"
      wrapProps={{ className: styles.trigger }}
    >
      {children}
    </Tooltip>
  );
});
